"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputWithIcon = exports.inputColorHover = exports.inputColorFocused = exports.inputColorReadOnly = exports.inputColorDisabled = exports.inputBase = void 0;

var _stylitas = require("@creditas/stylitas");

var inputBase = function inputBase(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  min-width: 100%;\n  min-height: 100%;\n  border: 0;\n  padding: 0;\n  font-size: 16px;\n  font-weight: 400;\n  outline: none;\n  color: ", ";\n  background: transparent;\n"])), _stylitas.utilities.typography.support(theme), _stylitas.utilities.palette.color(theme, 'neutral07'));
};

exports.inputBase = inputBase;

var inputColorDisabled = function inputColorDisabled(_ref2) {
  var theme = _ref2.theme,
      disabled = _ref2.disabled;
  return disabled && (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), _stylitas.utilities.palette.color(theme, 'neutral05'));
};

exports.inputColorDisabled = inputColorDisabled;

var inputColorReadOnly = function inputColorReadOnly(_ref3) {
  var theme = _ref3.theme,
      readOnly = _ref3.readOnly;
  return readOnly && (0, _stylitas.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), _stylitas.utilities.palette.color(theme, 'neutral07'));
};

exports.inputColorReadOnly = inputColorReadOnly;

var inputColorFocused = function inputColorFocused(_ref4) {
  var theme = _ref4.theme,
      readOnly = _ref4.readOnly;
  return !readOnly && (0, _stylitas.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), _stylitas.utilities.palette.color(theme, 'neutral09'));
};

exports.inputColorFocused = inputColorFocused;

var inputColorHover = function inputColorHover(_ref5) {
  var theme = _ref5.theme,
      inputFocus = _ref5.inputFocus,
      disabled = _ref5.disabled,
      readOnly = _ref5.readOnly;
  return !inputFocus && !disabled && !readOnly && (0, _stylitas.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), _stylitas.utilities.palette.color(theme, 'neutral08'));
};

exports.inputColorHover = inputColorHover;

var inputWithIcon = function inputWithIcon(_ref6) {
  var variant = _ref6.variant;
  return variant !== 'default' && (0, _stylitas.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    min-width: calc(100% - 30px);\n  "])));
};

exports.inputWithIcon = inputWithIcon;